exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-contain[data-v-2e9499ec]{position:relative}.upload-contain .demo-upload-list-cover[data-v-2e9499ec]{position:absolute;inset:0;display:none;background:rgba(0,0,0,.6)}.upload-contain .demo-upload-list-cover i[data-v-2e9499ec]{color:#fff}.upload-contain:hover .demo-upload-list-cover[data-v-2e9499ec]{display:block;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}", ""]);

// exports
